import { call, put, select } from 'redux-saga/effects';
import cirrusClient from '../../../services/api/cirrus-client';
import { setMessageSession, setPinnedMessageSessions } from '../../../state/message/messageSessionSlice';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';
import { setPinnedMessageSessions as setPinnedMessageSessionsPlatform } from '../../../browser/storage';

export function* fetchMessageSessionSaga() {
  try {
    const { domain, user, uid } = yield select(selectUserCredentials);
    const response = yield call(cirrusClient.get, `/v2/domains/${domain}/users/${user}/messagesessions`);
    const fetchedSessions = response.data;
    yield put(setMessageSession(fetchedSessions));

    //Vet pinned sessions if necessary
    const fetchedSessionIds  = new Set(fetchedSessions.map(session => session['messagesession-id']));
    const currentPinnedSessions = yield select(state => state.messageSession.pinnedMessageSessions);
    const validPinnedSessions  = currentPinnedSessions.filter(sessionId => fetchedSessionIds.has(sessionId));
    if (validPinnedSessions .length !== currentPinnedSessions.length) {
      yield put(setPinnedMessageSessions(validPinnedSessions ));
      yield call(setPinnedMessageSessionsPlatform, { uid, pinnedMessageSessionIds: validPinnedSessions  });
    }

  } catch (error) {
    console.error('Error fetching message sessions:', error);
  }
}